// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"fk","imgTextCardBox":"fk","text-box":"fl","textBox":"fl","remark-val":"fm","remarkVal":"fm"};